/* 
- Get details for the NAICS code selected by the user in the TreeView component from the Directus CMS
- Pass results to DetailPane
 */
import axios from "axios";

export function getAPIConnexion(query, lang, url) {
    return axios({
      method: "POST",
      url: url,
      data: {
        query: `
          {
            naics_2017(
              limit:-1,              
              filter:{
              ${query}
              })
            {
              id,
              title_${lang},
              definition_${lang},
              inclusions_${lang} {
                inclusion
              },
              examples_${lang} {
                id,
                example,
                exceptions
              },
              exclusions_${lang} {
                exclusion
              }
            }
          }
        `
      }
    }).then(response => { 
      return response;
    }).catch((error) => console.log(error.response.request._response));
  }
